/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import e from"../request.js";async function r(r,t){return(await e(r,{responseType:"image",...t})).data}export{r as requestImage};
